import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneBanner from './submodules/clone';
import CreateBanner from './submodules/create';
import ListBanner from './submodules/list';
import EditBanner from './submodules/edit';
import VersionHistory from './submodules/versionHistory';
import ShowChanges from './submodules/showChanges';

const BannerDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.banner}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].getAllBanners]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListBanner}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.banner}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].addBanners]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneBanner}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.banner}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].addBanners]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateBanner}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.banner}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].updateBannerStatus]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditBanner}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.banner}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].showVersionHistory]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/versionHistory`}
				component={VersionHistory}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.banner}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.banner].showVersionHistory]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/showChanges`}
				component={ShowChanges}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default BannerDashboard;
